import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Workshops from '../components/Workshops';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const WorkshopsPage = () => {
  const [activeSection, setActiveSection] = useState('workshops');
  const location = useLocation();

  useEffect(() => {
    const requestedSection = location.hash.slice(1);
    const sectionId = !requestedSection ? 'workshops' : requestedSection === 'contact' ? 'contact' : null;
    const frame = sectionId ? requestAnimationFrame(() => {
      const element = document.getElementById(sectionId);
      if (!element) return;
      setActiveSection(sectionId);
      element.scrollIntoView({ behavior: 'auto', block: 'start' });
      element.focus({ preventScroll: true });
    }) : null;

    const handleScroll = () => {
      const sections = ['workshops', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      if (frame !== null) cancelAnimationFrame(frame);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-white dark:bg-dark-900">
      <Header activeSection={activeSection} />
      <main id="main-content" tabIndex={-1} className="pt-16">
        <Workshops />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default WorkshopsPage;
